// extracted by mini-css-extract-plugin
export default {"wrapper":"Tm-z","response":"Um-z","error":"Vm-z","disabled":"Wm-z","buttons":"Xm-z","feedbackQuestionSection":"Ym-z","yesNoWrapper":"Zm-z"};